<div class="mapa-card">
    <app-mapa-uf class="mapa-uf" [ufSelecionada]="uf()" (estadoSelecionado)="aoSelecionarNoMapa($event)"></app-mapa-uf>
</div>
